// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");

function use(queryDraftId, serverDraftId, setDraftId) {
  React.useEffect(() => {
    if (queryDraftId !== undefined) {
      if (serverDraftId !== undefined) {
        if (queryDraftId !== serverDraftId) {
          setDraftId(serverDraftId);
        }
      } else {
        setDraftId(undefined);
      }
    } else if (serverDraftId !== undefined) {
      setDraftId(serverDraftId);
    }
  }, [
    queryDraftId,
    serverDraftId
  ]);
}

exports.use = use;
/* react Not a pure module */
